import React from 'react';
import {Text, IconTooltip} from '@forecast-it/design-system';
import {getGranularity} from '../../../util/cache/TimeRegistrationSettingsUtil';
import {getGranularityInfoLabel, Granularity} from '../../../../admin-tab/time-management/constants/Granularity';

type TimeRegGranularityInfoProps = {
	granularity: Granularity;
};

function TimeRegGranularityInfo({granularity}: TimeRegGranularityInfoProps): JSX.Element {
	const granularityLabel = getGranularityInfoLabel(granularity);
	return (
		<div>
			<Text size={'2'}>{granularityLabel}</Text>
			<Text size={'2'} color={'medium'}>
				This is a company-wide setting configured by your admin
			</Text>
		</div>
	);
}

export function TimeRegGranularityInfoIcon(): JSX.Element | null {
	const granularity = getGranularity();
	if (granularity === Granularity.Minutes) return null;
	return (
		<IconTooltip icon={'info'} color={'disabled'} iconSize={'s'} width={'l'}>
			<TimeRegGranularityInfo granularity={granularity} />
		</IconTooltip>
	);
}
